import { SetStateAction, useEffect } from 'react';
import {
	Button,
	Dialog,
	DialogBody,
	DialogSurface,
	DialogContent,
	DialogActions,
	DialogTitle,
	makeStyles,
	Spinner,
	tokens,
	DialogOpenChangeEvent,
	DialogOpenChangeData
} from '@fluentui/react-components';
import {
	useFetchProfileIconsQuery,
	useSetProfileIconMutation
} from '../Api/Players/playersSlice';

export interface IconSelectionProps {
	isOpen: boolean;
	setIsOpen: React.Dispatch<SetStateAction<boolean>>;
	username: string;
}

export default function IconSelection(props: IconSelectionProps) {
	const styles = useStyles();
	const { data: icons, isLoading } = useFetchProfileIconsQuery(undefined);
	const [setIcon, { isLoading: isSaving, isSuccess }] =
		useSetProfileIconMutation();

	useEffect(() => {
		if (isSuccess) {
			props.setIsOpen(false);
		}
	}, [isSuccess, props]);

	return (
		<Dialog
			open={props.isOpen}
			onOpenChange={(
				_event: DialogOpenChangeEvent,
				data: DialogOpenChangeData
			) => {
				props.setIsOpen(data.open);
			}}
		>
			<DialogSurface>
				<DialogTitle>Icons</DialogTitle>
				<DialogBody>
					<DialogContent>
						<div className={styles.container}>
							{isSaving && (
								<div
									style={{
										position: 'absolute',
										top: 0,
										bottom: 0,
										left: 0,
										right: 0
									}}
								>
									<Spinner />
								</div>
							)}
							{isLoading ? (
								<Spinner />
							) : (
								icons?.map((icon, index) => (
									<div
										className={styles.icon}
										key={`icon-${String(index)}`}
									>
										<img
											src={icon.url}
											alt={icon.displayName}
											height='100px'
											title={icon.displayName}
											onClick={() =>
												void setIcon({
													username: props.username,
													iconFileName: icon.fileName
												})
											} //I should pass the file name itself down so I can send it here
										/>
									</div>
								))
							)}
						</div>
					</DialogContent>
					<DialogActions>
						<Button
							type='button'
							appearance='secondary'
							onClick={() => {
								props.setIsOpen(false);
							}}
						>
							Cancel
						</Button>
					</DialogActions>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
}

const useStyles = makeStyles({
	container: {
		display: 'flex',
		flexWrap: 'wrap',
		columnGap: '4px',
		rowGap: '14px',
		justifyContent: 'left',
		alignItems: 'center'
	},
	icon: {
		width: '153px',
		margin: 'auto',
		padding: '3px',
		cursor: 'pointer',
		':hover': {
			boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
			backgroundColor: tokens.colorBrandBackground,
			borderRadius: '5px'
		},
		textAlign: 'center'
	}
});
